import LayoutComponent from "../components/LayoutComponent";
import {Button, Form, Input} from "antd";
import {useState, useEffect} from 'react';
import {useApi} from "../provider/ApiProvider";
import { Collapse } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import InfoAppDialog from "../dialogs/InfoAppDialog";

const { Panel } = Collapse;

const {TextArea} = Input;

export default function InfoPage(props){
    const {api, openToast} = useApi();

    const [loading, setLoading] = useState(false);
    const [infos, setInfos] = useState([]);
    const [form] = Form.useForm();
    const [dialog, setDialog] = useState({open: false, data: null})


    useEffect(() => {
        load();
    }, [])

    async function load(){
            await api.get('/infoAppRouter/info/all').then(resp => {
                setInfos(resp.data);
            }).finally(() => {

            })
    }

    function openEditDialog(data){
        setDialog({open: true, data: data});
    }

    async function save(values){

        // setLoading(true);
        // await api.put('/infoAppRouter/info/update/' + data.id, values).then(resp => {
        //     openToast('success', 'Metin Güncellendi')
        //     setLoading(false);
        // }).finally(() => {
        //     setLoading(false);
        // })


    }

    return (
        <LayoutComponent title={"Tanıtım"} links={
            [
                {
                    title: 'Anasayfa',
                    url: '/'
                },
                {
                    title: 'Tanıtım',
                    url: '/info'
                },

            ]}
        >
            <div>
                <div style={{display: 'flex', justifyContent: 'end', marginBottom: '10px'}}>
                    <Button className="submit-btn" onClick={() => setDialog({open: true, data: null})} type="primary" htmlType="submit">
                        Yeni Ekle
                    </Button>
                </div>
                {infos.length > 0 && (

                    <Collapse defaultActiveKey={['1']} onChange={() => {console.log('yess')}}>
                    {infos.map((item, idx) => (
                        <Panel header={item.Customer?.name} key={idx + 1}>
                            <div dangerouslySetInnerHTML={{ __html: item.content }} />

                            <div style={{display: 'flex', justifyContent: 'end'}}>
                                <Button
                                    type="primary"
                                    icon={<EditOutlined />}
                                    size={"medium"}
                                    onClick={() => openEditDialog(item)}
                                />
                            </div>
                        </Panel>
                    ))}



                </Collapse>
                )}
            <InfoAppDialog
                data={dialog.data}
                open={dialog.open}
                onChange={() => load()}
                onClose={() => {setDialog({open:false, data: null})}}
            />
            </div>
        </LayoutComponent>
    )
}
